import { createImageUploadHandler, setupTinyMCEEventHandlers } from '@/utils/tinymce-image-upload';

export const NOTIFICATION_EDITOR_CONFIG = {
  height: 400,
  menubar: false,
  statusbar: false,
  plugins: ["autolink lists link preview", "help"],
  toolbar:
    "undo redo | blocks | bold italic | uploadimage link | \
alignleft alignright alignjustify | \
bullist numlist outdent indent | removeformat | help ",
  images_upload_handler: createImageUploadHandler(),
  automatic_uploads: true,
  setup: setupTinyMCEEventHandlers,
};

export const NOTIFICATION_GENERAL_TYPE = "General";
export const NOTIFICATION_DRAFT_STATUS = 0;
export const NOTIFICATION_PUBLISH_STATUS = 1;
export const NOTIFICATION_DELETED_STATUS = 2;
